export const isAppleIOS = () => {
  const isIPhone = navigator.userAgent.toLowerCase().indexOf('iphone') !== -1;
  const isIPod = navigator.userAgent.toLowerCase().indexOf('ipod') !== -1;
  // this will detect iPad with iOS version < 13
  const isOldIPad = navigator.userAgent.toLowerCase().indexOf('ipad') !== -1;
  // this will detect iPadOS
  const isNewPad =
    !isOldIPad &&
    navigator.userAgent.match(/Mac/) &&
    navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 2;
  const isIPad = isOldIPad || isNewPad;

  return isIPhone || isIPod || isIPad;
};
